import { POST_FORM_CACHE } from "@circle-react/components/constants";
import { useModal } from "@circle-react/components/Layout/ModalManagerProvider";
import type { PostFormValues } from "@circle-react/components/QuickPostV3/data/types";
import { usePersistFormFields } from "@circle-react/hooks/utils/usePersistFormFields";
import { useFormContext } from "react-hook-form";

interface UsePersistDraftOptions {
  enabled?: boolean;
  variant: "create" | "edit";
}

export const usePersistDraft = ({
  enabled: shouldPersistDraft = true,
  variant,
}: UsePersistDraftOptions) => {
  const modal = useModal();
  const {
    formState: { isDirty, isSubmitSuccessful, isSubmitting },
  } = useFormContext<PostFormValues>();
  const isEdit = variant === "edit";

  usePersistFormFields({
    cacheKey: POST_FORM_CACHE,
    fields: ["name", "body", "tiptap_body", "space_id", "cover_image"],
    enabled:
      modal.visible &&
      isDirty &&
      !isEdit &&
      !isSubmitting &&
      !isSubmitSuccessful &&
      shouldPersistDraft,
  });
};
